import {useTranslation} from '@aboutyou/i18n';

export const useCustomerServiceTranslations = (): Record<string, string> => {
  const {t} = useTranslation();

  return {
    chat_support_subline: t('Instant assistance from our chatbot'),
    chat_support: t('Chat Support'),
    chat_with_us: t('Chat with us'),
    get_instant_help: t(
      'Get 24/7 help from our Chatbot and avoid waiting times.',
    ),
    give_us_a_call: t('Give us a call'),
    start_chat: t('Start Chat'),
  };
};
